const WinlosesTypes = {
    FETCH_START:    '[MANAGERS] FETCH START',
    FETCH_SUCCESS:  '[MANAGERS] FETCH SUCCESS',
    FETCH_FAILURE:  '[MANAGERS] FETCH FAILURE'
};

export default WinlosesTypes;